export default () => ({
    open: false,
    title: null,
    size: null,
    id: null,
    tosAccepted: false,
    validEmail: false,
    userSubscribed: false,
   
    hide() {
      this.open = false;
      this.title = null;
      this.size = null;
      this.id = null;
      this.userSubscribed = false;

      Grebify.noScroll(false);
    },
  
    show(title, size, id) {        
      this.title = title
      this.id= id;
      this.size = size === "ONESI" ? "ONESIZE" : size;
      this.open = true;
      Grebify.noScroll(true);
    },

    validateInput(event) {
      const emailValue = event.target.value;
      if(this.validateEmail(emailValue)){
        this.validEmail = true;
      }

    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    onTosChange(checked) {
      this.tosAccepted = checked;
    },

    async registerSignup() {
      try {

        const email = document.querySelector("[name='back-in-stock-email']").value;

        const options = {
          method: 'POST',
          headers: {
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
            revision: '2024-10-15',

          },
          body: `{"data":{"type":"back-in-stock-subscription","attributes":{"profile":{"data":{"type":"profile","attributes":{"email":"${email}"}}},"channels":["EMAIL"]},"relationships":{"variant":{"data":{"type":"catalog-variant","id":"$shopify:::$default:::${this.id}"}}}}}`
        };
        
       const response = await fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=S6tNs4', options)
        
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }

          this.userSubscribed = true;

      } catch (err) {
      } finally {
      }
  }
  });

